// This optional flag shows manual Start/reminder UI. Active recording Stop
// and save recovery remain visible to admitted hosts with server permission.
export const RECORDING_UI_ENABLED = process.env.REACT_APP_RECORDING_UI_ENABLED === 'true';
